import React, { Component } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  Popover,
  Button,
  PopoverBody,
  Container,
  Row,
  Col
} from 'reactstrap';

import "./Slideshow.css"
const items = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-1.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-2.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-3.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-4.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-5.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-6.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-7.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-8.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-9.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-10.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-11.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-12.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-13.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-14.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-15.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-16.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-17.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-18.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-19.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-20.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-21.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-22.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-23.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-24.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-25.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-26.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-27.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-28.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-29.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-30.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-31.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-32.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-33.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-34.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-35.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-36.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-37.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-38.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-39.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-40.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-41.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-42.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-43.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-44.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-45.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-46.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-47.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-48.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-49.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-50.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-51.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-52.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-53.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-54.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-55.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-56.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-57.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-58.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-59.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-60.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-61.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-62.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-63.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-64.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-65.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-66.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-67.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-68.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-69.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-70.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-71.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-72.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-73.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-74.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-75.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-76.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-77.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-78.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-79.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-80.jpg"
  }
];

class Slideshow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      popoverOpen: false
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }
  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }



  render() {
    const { activeIndex } = this.state;

    const slides = items.map((item) => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}

        >
          <img src={item.src} alt={item.altText} className="img-fluid d-block mx-auto" />

        </CarouselItem>
      );
    });

    return (
      <Container className="content-wrapper p-b-0">
        <Row className="top-banner">
          <Col md="6" className="left">
            <div>
              <p className="small-text">
                GET AHEAD OF THE COMPETITION
              </p>
              <h1>
                Welcome, please take part of the course material
              </h1>
              <ul className="d-none d-sm-none d-md-block d-lg-block">
                <li>
                  <a className="int-btn blue-btn" href="#materials">
                    VIEW NOW
                  </a>
                </li>
                <li>
                  <Button id="Popover1" className="int-btn green-btn" onClick={this.toggle}>
                    PERMISSIONS POLICY
            </Button>
                  <Popover placement="bottom" isOpen={this.state.popoverOpen} target="Popover1" toggle={this.toggle}>

                    <PopoverBody>The rights granted to this material do not permit the license to (1) claim authorship of the content represented; (2) transfer, share or sub-lease this content with any other party; (3) copy or duplicate the work; (4) permit any other individual or third party the right to use the work in place of the original copyright owner; (5) resell, trade, or exploit for profit the work contained herein outright or as part of other educational and/or informative-related content, in part or in whole, to any other individual or party.</PopoverBody>
                  </Popover>
                </li>
              </ul>
            </div>
          </Col>
          <Col md="6" className="right">
            <img
              className="img-fluid"
              src={require("../../img/integrator-process.png")}
              alt="Integrator"
            />
          </Col>
          <ul className="d-lg-none d-md-none d-sm-block d-xs-block">
            <li>
              <a className="int-btn blue-btn" href="#materials">
                VIEW NOW
              </a>
            </li>
            <li>
              <Button id="Popover1" className="int-btn green-btn" onClick={this.toggle}>
                PERMISSIONS POLICY
            </Button>
              <Popover placement="bottom" isOpen={this.state.popoverOpen} target="Popover1" toggle={this.toggle}>
                <PopoverBody>The rights granted to this material do not permit the license to (1) claim authorship of the content represented; (2) transfer, share or sub-lease this content with any other party; (3) copy or duplicate the work; (4) permit any other individual or third party the right to use the work in place of the original copyright owner; (5) resell, trade, or exploit for profit the work contained herein outright or as part of other educational and/or informative-related content, in part or in whole, to any other individual or party.</PopoverBody>
              </Popover>
            </li>
          </ul>
        </Row>
        <Carousel
          activeIndex={activeIndex}
          next={this.next}
          previous={this.previous}
          interval={false}

        >
          {slides}
          <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
          <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
        </Carousel>
        <p className="copyright" id="materials">Copyright © 2021 Entiros. All rights reserved</p>
      </Container>
    );
  }
}


export default Slideshow;
